
export class ReqCategoryList {
    constructor({ start, limit, type }) {
        this.start = start
        this.limit = limit
        this.type = type
    }

    fromJson(jsonData) {
        this.start = jsonData.start
        this.limit = jsonData.limit
        this.type = jsonData.type
    }
}

export class ReqCategory { 
    constructor({categoryId, categoryName, items, type}) {
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.items = items
        this.type = type
    }

    fromJson(jsonData) {
        this.categoryId = jsonData.categoryId
        this.categoryName = jsonData.categoryName
        this.items = jsonData.items
        this.type = jsonData.type
    }
}

export class ReqCategoryItem {
    constructor({ categoryId, type }) {
        this.categoryId = categoryId
        this.type = type
    }

    fromJson(jsonData) {
        this.categoryId = jsonData.categoryId
        this.type = jsonData.type
    }
}

export class RespCategoryItem {
    fromJson(jsonData){
        this.categoryId = jsonData.categoryId
        this.categoryName = jsonData.categoryName
        this.count = jsonData.count
        this.items = JSON.parse(jsonData.items) 
    }
}

export class RespCategoryListPageItem{
    fromJson(jsonData){

    }
}